import 'angular';

import 'bootstrap-legacy';

import '../vendor/chosen/chosen.min';
import '../vendor/sprintf/sprintf';

import '../app-lite/app.module.ajs';

import './core/core.module';

angular.module('app', [
  'app-lite',
  'app.core'
]);
